import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { payActions } from '../../../application/actions/pay';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// GETBYID
export function* getByIdFetch(e) {
    yield put(payActions.conexionGetById({connection:true}));
    try {
        const  params  = e.payload;
        const url = `pay/${params.id}`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(payActions.getById({data}));
    } catch (err) {
        yield put(payActions.errorGetById({error:true, message:err.message}));
    } finally {
        yield put(payActions.conexionGetById({connection:false}));
    }
}

// CREATE
export function* createFetch(e) {
    yield put(payActions.conexionCreate({connection:true}));
    try {
        const  params  = e.payload;
        const url = `pay`
        const response = yield call(
            apiRequest.post,
            url,
            params
        );

        // Extraigo todos los datos
        const { result } = response;
        yield put(payActions.create({result}));
    } catch (err) {
        yield put(payActions.errorCreate({error:true, message:err.message}));
    } finally {
        yield put(payActions.conexionCreate({connection:false}));
    }
}


export function* watchFetchPay() {
    yield takeLatest(payActionsSaga.getById.type,  getByIdFetch);
    yield takeLatest(payActionsSaga.create.type,  createFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchPay);
}


const getById = createAction('paySaga/getById');
const create = createAction('paySaga/create');

export const payActionsSaga = {
    getById,
    create,
};
